import React from 'react';

import './MailACheck.scss';

import SharedMailACheck from './SharedMailACheck';
import config from '../../../config/config';
import { DELIVERY_MAIL_CHECK_REDEMPTION } from '../../../settings/settings';
import { Address } from './Address';
import If from '../../Shared/If/If';
// import words from '../../../utils/words';
import {
  isAppSell,
  isCollegeDistribute,
  isAutomaticSell,
  isSell,
} from '../../../utils/transactions-util';
import {
  calculateAndFormatUnixDates,
  futureDate,
  getCurrentDate,
} from '../../../utils/dates/date-utility';
import { currencyNoPrecision } from '../../../utils/utils';
import errorIcon from '../../../assets/images/error-icon.svg';

const MailACheck = ({
  isSalesforceRep,
  customerWebViewEnabled,
  address,
  effectiveAddressChangedFlag,
  effectiveDate,
  isAddressChangedOnSameDay,
  multipleAddressFlag,
  maxRedumption,
}) => (
  <div className="mail-a-check e2e-mail-a-check-container">
    <If test={!isCollegeDistribute() && !multipleAddressFlag}>
      <If test={!effectiveAddressChangedFlag}>
        <SharedMailACheck
          isSalesforceRep={isSalesforceRep}
          customerWebViewEnabled={customerWebViewEnabled}
          heading={
            <div>
              <span className="hidden-sm hidden-xs">Mailing address</span>
              <span className="hidden-lg hidden-md">Address</span> on file:
            </div>
          }
          mobileAddress={true}
          dailyMax={true}
          address={<Address address={address} />}
          description={
            <div className="hidden-sm hidden-xs">
              {!customerWebViewEnabled && isSalesforceRep ? (
                <span></span>
              ) : (
                <span>
                  If this is not your current address, please update your{' '}
                  <a
                    className="text-nowrap college-branded-link mail-a-check-link"
                    href={`${config.url}/usis/my-accounts/profile/contact-information`}
                  >
                    Contact Information
                  </a>
                  . During the 15 days following a change to your mailing
                  address of record, proceeds from a redemption submitted online
                  can be sent only to a previously linked bank account and
                  cannot be sent by check.
                  {isAutomaticSell() && (
                    <div className="pt-15">
                      <b>
                        Please{' '}
                        <a
                          className="text-nowrap college-branded-link mail-a-check-link"
                          href={`https://www.troweprice.com/personal-investing/help/contact/index.html`}
                        >
                          contact
                        </a>{' '}
                        us to discuss the options available to you for placing a
                        redemption.
                      </b>
                    </div>
                  )}
                </span>
              )}
            </div>
          }
        />
      </If>
      <If test={effectiveAddressChangedFlag}>
        <SharedMailACheck
          heading={
            <div className="mail-a-check-heading-unavailable">
              <img alt="" src={errorIcon} className="mail-a-check-error-icon" />
              Mailing a check unavailable
            </div>
          }
          description={
            <div>
              You recently updated your mail address. In order to protect your
              investments, during the 15 days following a change to your mailing
              address of record, proceeds from a redemption submitted online can
              be sent only to a previously linked bank account and cannot be
              sent by check.
            </div>
          }
          availableDate={
            <div>
              This option will be available online on
              <span className="mail-a-check-date">
                {' '}
                {isAddressChangedOnSameDay
                  ? calculateAndFormatUnixDates(
                      futureDate(getCurrentDate(), 15),
                      'MM/DD/YY'
                    )
                  : calculateAndFormatUnixDates(
                      futureDate(effectiveDate, 15),
                      'MM/DD/YY'
                    )}
                .
              </span>
            </div>
          }
        />
        <p className="footer-contact-us-link">
          Please{' '}
          <a
            id="lb-contact-link"
            className="text-nowrap e2e-option-link"
            href={`${config.url}/personal-investing/help/contact-us.html`}
            style={{ textDecoration: 'underline' }}
            target="_blank"
            rel="noreferrer"
          >
            contact us
          </a>{' '}
          to discuss the options available to you for placing a redemption.
        </p>
      </If>
    </If>
    <If test={isCollegeDistribute() || multipleAddressFlag}>
      <SharedMailACheck
        heading={isCollegeDistribute() ? '' : 'Multiple addresses on file'}
        description={
          <div className="mail-a-check-multiple-address">
            <span>
              Checks will be sent to the mailing address associated with each{' '}
              {isCollegeDistribute()
                ? 'account and payee (account holder or beneficiary)'
                : isAppSell()
                ? 'account'
                : 'fund'}{' '}
              selected.
            </span>{' '}
            You will be able to review all addresses before submitting in Step{' '}
            {isAutomaticSell() ? '4' : '3'}.
            {isSell() &&
              ' If you change your address of record, during the 15 days following a change to your mailing address of record, proceeds from a redemption submitted online can be sent only to a previously linked bank account and cannot be sent by check.'}
            <div className="mail-a-check-check-daily-max">
              {!customerWebViewEnabled && isSalesforceRep ? (
                <span></span>
              ) : (
                <span>
                  {isCollegeDistribute()
                    ? `The maximum amount that may be distributed from a 529 account is ${maxRedumption} per day.`
                    : `The maximum redemption amount that may be requested online and sent via check is ${currencyNoPrecision(
                        DELIVERY_MAIL_CHECK_REDEMPTION
                      )} per day.`}
                </span>
              )}
            </div>
          </div>
        }
      />
    </If>
  </div>
);

export default MailACheck;
